// extracted by mini-css-extract-plugin
module.exports = {"NoColorBackdrop":"NoColorBackdrop_NoColorBackdrop__4IPwq"};